import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { paidUploadLimit } from 'reactApp/appHelpers/featuresHelpers/features/paidUploadLimit';

const HEAVY_FILE_UPLOAD_LIMIT_EXP = 'heavy-file-upload-limit-exp';

export const UPLOAD_LIMITS = {
    v1: 102005473280, // 95 ГБ
    v2: 107374182400, // 100 ГБ
    v3: 91268055040, // 85 ГБ
    v4: 85899345920, // 80 ГБ
};

export const heavyFileUploadLimitExpEnabled = isFeature(HEAVY_FILE_UPLOAD_LIMIT_EXP);

export const getUploadLimitByProductId = (productId: string | undefined | null, defaultLimit: number = paidUploadLimit): number => {
    if (!heavyFileUploadLimitExpEnabled || !productId) {
        return defaultLimit;
    }

    if (!productId.includes('elastic_prices_exp')) {
        return defaultLimit;
    }

    if (productId.includes('_v4')) {
        return UPLOAD_LIMITS.v4;
    }

    if (productId.includes('_v3')) {
        return UPLOAD_LIMITS.v3;
    }

    if (productId.includes('_v2')) {
        return UPLOAD_LIMITS.v2;
    }

    if (productId.includes('_v1')) {
        return UPLOAD_LIMITS.v1;
    }

    return defaultLimit;
};
